import React, { Component } from "react";
import "./Item.css";
import { Button } from "react-bootstrap";
import TestImage from "../../../Images/TestImage.svg";
import AddItemToCategory from "../../MaterialComponents/DropDownMenu/AddItemToCategory";
import ItemClimateComponent from "../ItemClimateComponent/ItemClimateComponent";
import NutrientInfo from "../NutrientInfo/NutrientInfo";

let langData = require("../../../Data/language.json");
const downArrow = String.fromCharCode(9660);
const upArrow = String.fromCharCode(9654);
export default class Item extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: TestImage,
      cat_name: langData[this.props.language].itemScreen.noCategory,
      name: this.props.item.name,
      eanCode: this.props.item.EANcode,
      showConsupedia: false,
      categoryExist: false,
      expandedNutrients: false,
    };
  }
  lastTouchEnd = 0;

  updateItem = (value) => {
    this.setState({
      categoryExist: true,
      cat_name: langData[this.props.language].categories[value],
    });
  };

  disableDoubleTap = (evt) => {
    const now = new Date().getTime();
    if (now - this.lastTouchEnd <= 300) {
      evt.preventDefault();
    }
    this.lastTouchEnd = now;
  };

  componentWillMount = () => {
    if (this.props.item.image !== "") {
      this.setState({ image: this.props.item.image });
    }
    if (this.props.item.cat_name !== "") {
      this.setState({
        cat_name:
          langData[this.props.language].categories[this.props.item.cat_name],
        categoryExist: true,
      });
    } else {
      console.log("no category");
    }
    if (this.props.item.fullname !== "") {
      this.setState({ name: this.props.item.fullname });
    }
    if (this.props.item.EANcode.length === 13) {
      this.setState({ showConsupedia: true });
    }
    // Disables double tap to zoom
    document.addEventListener("touchend", (evt) => this.disableDoubleTap(evt));
  };

  componentWillUnmount() {
    document.removeEventListener("touchend", this.disableDoubleTap);
  }

  render() {
    if (this.state.categoryExist === false) {
      var category = (
        <div className="AddItemSection">
          <p>{langData[this.props.language].itemScreen.addCategory}</p>
          <AddItemToCategory
            updateCategory={this.props.updateCategory}
            ean={this.props.item.EANcode}
            updateItem={this.updateItem}
          />
        </div>
      );
    } else {
      category = <p className="subText"> {this.state.cat_name}</p>;
    }

    return (
      <div className="itemDiv">
        <p id="itemTitle">{this.state.name}</p>
        <div id="itemImageWrapper">
          {this.props.item.average_price && (
            <div id="itemPriceContainer">
              <p id="itemPriceDesciption">
                {langData[this.props.language].climate.item.avgPrice}
              </p>
              <p id="itemPriceText">
                {this.props.item.average_price.replace(".", ":")} SEK
              </p>
            </div>
          )}

          <img
            src={this.state.image}
            className="itemImage"
            alt={this.props.item.name}
          />
        </div>

        <hr />

        <p className="subTitle">
          {langData[this.props.language].itemScreen.category}{" "}
        </p>
        {category}
        <hr />
        <div className="row">
          <div className="container-fluid col-12 col-sm-12 col-md-12 climateValueWrapper">
            <p className="subTitle">
              {langData[this.props.language].itemScreen.environmentalData}
            </p>
            <ItemClimateComponent
              carbon_fp={this.props.item.carbon_fp}
              water_fp={this.props.item.water_fp}
              language={this.props.language}
            />
          </div>
        </div>
        <hr />
        <div
          id="nutrientContainer"
          onClick={() => {
            this.setState({ expandedNutrients: !this.state.expandedNutrients });
          }}
        >
          <div id="nutrientTitleWrapper">
            <p className="subTitle">
              {langData[this.props.language].nutrients.nutrients}
            </p>
            <p className="expandArrow">
              {this.state.expandedNutrients ? downArrow : upArrow}
            </p>
          </div>
          {this.state.expandedNutrients && (
            <NutrientInfo
              language={this.props.language}
              data={this.props.item.nutrients}
            />
          )}
        </div>
        <hr />
        {this.props.item.cat_id === "" ? (
          ""
        ) : (
          <div className="container-fluid col-12 consupediaLink">
            <p className="subTitle">
              {langData[this.props.language].itemScreen.learnMore}
            </p>

            <div className="container-fluid col-7 col-sm-5 col-md-4 logoWrapper">
              <a href={"https://consupedia.se/products/" + this.state.eanCode}>
                <img
                  className="Logo"
                  src={require("../../../Images/ConsupediaLogo.png")}
                  alt="Consupedia Logo"
                />
              </a>
            </div>
            <p id="knowMoreText">
              {langData[this.props.language].itemScreen.consupediaInfo}
            </p>
          </div>
        )}
      </div>
    );
  }
}
